import { render, staticRenderFns } from "./ForumThreadPageAsideThreads.vue?vue&type=template&id=0a81c6fe&scoped=true"
import script from "./ForumThreadPageAsideThreads.vue?vue&type=script&lang=js"
export * from "./ForumThreadPageAsideThreads.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadPageAsideThreads.vue?vue&type=style&index=0&id=0a81c6fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81c6fe",
  null
  
)

export default component.exports